export default "__VITE_ASSET__CVYYV1RK__"